<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h3 class="mt-2 mb-2">
                    {{ id && id > 0 ? "Update" : "Add" }} Invoice Draft
                </h3>
                <div class="row">
                    <div class="col-3">
                        <div class="form-group">
                            <label>Invoice Date</label>
                            <datepicker
                                v-model="xInvoiceDate"
                                format="yyyy-MM-dd"
                                input-class="form-control"
                            />
                            <small class="text-danger" v-if="getFieldError('invoice_date')">
                                {{ getFieldError('invoice_date') }}
                            </small>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <label>Period From</label>
                            <datepicker
                                v-model="xInvoicePeriodStart"
                                format="yyyy-MM-dd"
                                input-class="form-control"
                            />
                            <small class="text-danger" v-if="getFieldError('invoice_period_start')">
                                {{ getFieldError('invoice_period_start') }}
                            </small>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <label>Period To</label>
                            <datepicker
                                v-model="xInvoicePeriodEnd"
                                format="yyyy-MM-dd"
                                input-class="form-control"
                            />
                            <small class="text-danger" v-if="getFieldError('invoice_period_end')">
                                {{ getFieldError('invoice_period_end') }}
                            </small>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <div class="form-group">
                            <label>Rental fee</label>
                            <select class="form-control" v-model="rentalFeeArticleId">
                                <option v-for="article in availableRentalFees" :value="article.article_id">
                                    {{ article.article_id != 30000 ? article.sale_price : 'CUSTOM' }}
                                </option>
                            </select>
                            <small class="text-danger" v-if="getFieldError('rentalFee')">
                                {{ getFieldError('rentalFee') }}
                            </small>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label>Description</label>
                            <input v-model="xRentalFeeComment" type="text" class="form-control">
                            <small class="text-danger" v-if="getFieldError('rentalFeeComment')">
                                {{ getFieldError('rentalFeeComment') }}
                            </small>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <label>Amount (excl. VAT)</label>
                            <input v-model="xRentalFee" type="number" class="form-control">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <div class="form-group">
                            <label>Ads package</label>
                            <select class="form-control" v-model="adsPackageArticleId">
                                <option v-for="article in availableAdsPackages" :value="article.article_id">
                                    {{ article.article_id != 30001 ? article.sale_price : 'CUSTOM' }}
                                </option>
                            </select>
                            <small class="text-danger" v-if="getFieldError('adsPackage')">
                                {{ getFieldError('adsPackage') }}
                            </small>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label>Description</label>
                            <input v-model="xAdsPackageComment" type="text" class="form-control">
                            <small class="text-danger" v-if="getFieldError('adsPackageComment')">
                                {{ getFieldError('adsPackageComment') }}
                            </small>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <label>Amount (excl. VAT)</label>
                            <input v-model="xAdsPackage" type="number" class="form-control">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <label>Discount</label>
                            <input v-model="xDiscount" type="text" class="form-control">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <label for="isSkipped">Skip sending to the customer:</label>
                            <input id="isSkipped" type="checkbox" v-model="xIsSkipped" style="margin: 10px 0 0 10px;"/>
                        </div>
                    </div>
                </div>
                <hr/>
                <div class="row">
                    <div class="col-12">
                        <button type="button" class="submitBtn btn btn-primary float-left mb-3"
                                @click="$emit('submit')"
                                :class="{'loading': loading}"
                                :disabled="loading"
                        >
                            <span>Submit</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
    name: 'InvoiceDraftForm',
    components: {
        Datepicker,
    },
    props: {
        id: { type: Number, required: false, default: null },
        invoiceDate: { type: Date, required: true, default: null },
        invoicePeriodStart: { type: Date, required: true, default: null },
        invoicePeriodEnd: { type: Date, required: true, default: null },
        rentalFee: { type: Number, required: true, default: null },
        rentalFeeComment: { type: String, required: false, default: null },
        adsPackage: { type: Number, required: true, default: null },
        adsPackageComment: { type: String, required: false, default: null },
        discount: { type: Number, required: true, default: null },
        isSkipped: { type: Boolean, required: true, default: null },
        loading: { type: Boolean, required: true, default: null },
        order: { type: Object, required: true, default: null },
    },
    data() {
        return {
            componentKey: 0,
            articles: [],
            errors: [],
            rentalFeeArticleId: null,
            adsPackageArticleId: null,
        };
    },
    mounted() {
        if (this.order.client.id > 0) {
            this.updateArticles();
        }
    },
    computed: {
        xInvoiceDate: {
            get() {
                return this.invoiceDate;
            },
            set(val) {
                this.$emit('update:invoiceDate', val);
            },
        },
        xInvoicePeriodStart: {
            get() {
                return this.invoicePeriodStart;
            },
            set(val) {
                this.$emit('update:invoicePeriodStart', val);
            },
        },
        xInvoicePeriodEnd: {
            get() {
                return this.invoicePeriodEnd;
            },
            set(val) {
                this.$emit('update:invoicePeriodEnd', val);
            },
        },
        xRentalFee: {
            get() {
                return this.rentalFee;
            },
            set(val) {
                this.$emit('update:rentalFee', parseInt(val));
            },
        },
        xRentalFeeComment: {
            get() {
                return this.rentalFeeComment;
            },
            set(val) {
                this.$emit('update:rentalFeeComment', val);
            },
        },
        xAdsPackage: {
            get() {
                return this.adsPackage;
            },
            set(val) {
                this.$emit('update:adsPackage', parseInt(val));
            },
        },
        xAdsPackageComment: {
            get() {
                return this.adsPackageComment;
            },
            set(val) {
                this.$emit('update:adsPackageComment', val);
            },
        },
        xDiscount: {
            get() {
                return this.discount;
            },
            set(val) {
                this.$emit('update:discount', parseInt(val));
            },
        },
        xIsSkipped: {
            get() {
                return this.isSkipped;
            },
            set(val) {
                this.$emit('update:isSkipped', val);
            },
        },
        availableRentalFees() {
            return this.articles.filter(article => article['type'] === 'rental_fee');
        },
        availableAdsPackages() {
            return this.articles.filter(article => article['type'] === 'ads_package');
        }
    },
    watch: {
        'order.client.id'() {
            this.updateArticles();
        },
        xInvoicePeriodStart: function () {
            this.updateAdsPackageDescription();
            this.updateRentalFeeDescription();
        },
        xInvoicePeriodEnd: function () {
            this.updateAdsPackageDescription();
            this.updateRentalFeeDescription();
        },
        xDiscount(newVal) {
            if (isNaN(newVal)) {
                this.xDiscount = 0;
            }
            if (newVal > 100) {
                this.xDiscount = 100;
            } else if (newVal < 0) {
                this.xDiscount = 0;
            }
        },
        rentalFeeArticleId(newVal, oldVal) {
            if (newVal != '30000') {
                const article = this.availableRentalFees.find(article => article.article_id == newVal);
                this.xRentalFee = article.sale_price;
            }
            if (newVal == '30000' || oldVal == '30000') {
                this.updateRentalFeeDescription();
            }
        },
        xRentalFee(newVal) {
            if (isNaN(newVal)) {
                this.xRentalFee = 0;
            }
            if (newVal < 0) {
                this.xRentalFee = 0;
            }
            const article = this.getArticleByPrice(this.availableRentalFees, newVal);
            this.rentalFeeArticleId = article ? `${article.article_id}` : '30000';
        },
        adsPackageArticleId(newVal, oldVal) {
            if (newVal != '30001') {
                const article = this.availableAdsPackages.find(article => article.article_id == newVal);
                this.xAdsPackage = article.sale_price;
            }
            if (newVal == '30001' || oldVal == '30001') {
                this.updateAdsPackageDescription();
            }
        },
        xAdsPackage(newVal) {
            if (isNaN(newVal)) {
                this.xAdsPackage = 0;
            }
            if (newVal < 0) {
                this.xAdsPackage = 0;
            }
            const article = this.getArticleByPrice(this.availableAdsPackages, newVal);
            this.adsPackageArticleId = article ? `${article.article_id}` : '30001';
        },
    },
    methods: {
        getFieldError(field) {
            if (field in this.errors) {
                return this.errors[field][0];
            }
            return null;
        },
        fetchArticles() {
            return new Promise((resolve, reject) => {
                axios.get('/client/articles/' + this.order.client.id).then((res) => {
                    resolve(res.data);
                }).catch(e => {
                    reject(e);
                });
            });
        },
        updateArticles() {
            this.fetchArticles().then((res) => {
                this.articles = res;
                let article = this.getArticleByPrice(this.availableRentalFees, this.xRentalFee);
                this.rentalFeeArticleId = article ? `${article.article_id}` : '30000';
                article = this.getArticleByPrice(this.availableAdsPackages, this.xAdsPackage);
                this.adsPackageArticleId = article ? `${article.article_id}` : '30001';
            }).catch((e) => {
                this.articles = [];
                console.log(e);
            });
        },
        getArticleById(id) {
            let article = null;
            this.articles.forEach(function (item) {
                if (item.article_id == id) {
                    article = item;
                }
            });
            return article;
        },
        getArticleByPrice(articles, price) {
            let article = null;
            articles.forEach(function (item) {
                if (item.sale_price == price) {
                    article = item;
                }
            });
            return article;
        },
        updateRentalFeeDescription() {
            const article = this.getArticleById(this.rentalFeeArticleId);
            const description = article && article.description !== null ? article.description : 'Rental Fee Custom';
            this.xRentalFeeComment = this.getDescriptionString(description);
        },
        updateAdsPackageDescription() {
            const article = this.getArticleById(this.adsPackageArticleId);
            const description = article && article.description !== null ? article.description : 'Ads Package Custom';
            this.xAdsPackageComment = this.getDescriptionString(description);
        },
        getDescriptionString(description) {
            let fromString = "-";
            let toString = "-";
            if (this.xInvoicePeriodStart instanceof Date) {
                fromString = this.xInvoicePeriodStart.toJSON().slice(0, 10);
            }
            if (this.xInvoicePeriodEnd instanceof Date) {
                toString = this.xInvoicePeriodEnd.toJSON().slice(0, 10);
            }
            return description + " (" + fromString + " - " + toString + ")";
        }
    },
    filters: {
        mapArticleName(article_id) {
            if (article_id == 30000 || article_id == 30001) {
                return 'CUSTOM';
            }
            return article_id;
        },
    },
}
</script>
<style>
.vm--modal {
    overflow: visible;
}
</style>
<style scoped>
.submitBtn {
    width: 80px;
    position: relative;
}

.submitBtn.loading span {
    visibility: hidden;
    opacity: 0;
}

.submitBtn.loading::after {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 2px solid transparent;
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: button-loading-spinner 1s ease infinite;
}

@keyframes button-loading-spinner {
    from {
        transform: rotate(0turn);
    }
    to {
        transform: rotate(1turn);
    }
}
</style>
